import {
  IEvent,
} from "../interfaces/map.interfaces";
import { message } from "antd";


export async function exportEventToJsonWithMessage(event: IEvent) {
  const hide = message.loading("Export in progress...", 0);
  await exportEventToJson(event);
  hide();
}

export async function exportEventToJson(event: IEvent) {

  const objectData = {
    type: "Feature",
    properties: event.properties,
    geometry: {
      type: "Point",
      coordinates: event.coordinates,
    },
  };

  let filename =  event.properties.id + ".json";
  let contentType = "application/json;charset=utf-8;";

  // we indent each level with 2 whitespaces
  let indentationLevels = 2;
  let jsonString = JSON.stringify(objectData, null, indentationLevels);

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    const blob = new Blob([decodeURIComponent(encodeURI(jsonString))], { type: contentType });
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    a.download = filename;
    a.href = 'data:' + contentType + ',' + encodeURIComponent(jsonString);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

// Helper function to escape CSV values
function escapeCSVValue(value: any): string {
  if (value === null || value === undefined) {
    return '';
  }
  
  const stringValue = String(value);
  
  // If the value contains comma, quote, or newline, wrap it in quotes and escape quotes
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n') || stringValue.includes('\r')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  
  return stringValue;
}

export async function exportEventsToCSV(events) {
  if (!events || events.length === 0) {
    console.warn('No events to export');
    return;
  }

  // Define the order of columns to match the table structure
  const columnOrder = [
    'id',
    'code',
    'area',
    'date',
    'state',
    'comment',
    'CH4',
    'markerName',
    'author',
    'type',
    'subType',
    'locationId',
    'projectId',
    'confidence',
  ];

  // Build the data array with all available fields from events
  let newEventsArr = [];
  for (let i = 0; i < events.length; i++) {
    let newEvent = {};
    
    // Add all fields that exist in the event, maintaining column order
    for (const key of columnOrder) {
      if (events[i].hasOwnProperty(key)) {
        newEvent[key] = events[i][key];
      }
    }
    
    // Add any additional fields that might exist
    for (const key in events[i]) {
      if (!columnOrder.includes(key) && events[i].hasOwnProperty(key)) {
        newEvent[key] = events[i][key];
      }
    }
    
    newEventsArr.push(newEvent);
  }

  // Get all unique keys from all events to ensure we have all columns
  const allKeys = new Set<string>();
  newEventsArr.forEach(event => {
    Object.keys(event).forEach(key => allKeys.add(key));
  });

  // Create ordered header row (prioritize columnOrder, then add others)
  const orderedKeys = [
    ...columnOrder.filter(key => allKeys.has(key)),
    ...Array.from(allKeys).filter(key => !columnOrder.includes(key))
  ];

  // Build CSV content
  const csvRows: string[] = [];

  // Add header row
  csvRows.push(orderedKeys.map(key => escapeCSVValue(key)).join(','));

  // Add data rows
  for (const event of newEventsArr) {
    const row = orderedKeys.map(key => escapeCSVValue(event[key]));
    csvRows.push(row.join(','));
  }

  const csvContent = csvRows.join('\n');

  // Create and trigger download
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' }); // BOM for Excel compatibility
  const url = URL.createObjectURL(blob);
  const hiddenElement = document.createElement('a');
  hiddenElement.href = url;
  hiddenElement.target = '_blank';
  hiddenElement.download = 'events_export.csv';
  document.body.appendChild(hiddenElement);
  hiddenElement.click();
  document.body.removeChild(hiddenElement);
  URL.revokeObjectURL(url);
}